import React from 'react';

export default function ActionCost({ cost }: { cost?: number }) {
  if (cost === undefined || cost === 1) {
    return null;
  }
  return (
    <span>
      {' '}
      <span className="button__more">
        (
        {cost}
        )
      </span>
    </span>
  );
}

ActionCost.displayName = 'ActionCost';
